module.exports = __webpack_public_path__ + "static/N2N2-4558d020cf06b0d608673caed60b24ae.jpg";